import { decideBranch } from '../flow-branches/decideBranch';
import { finishSignup, goNextStep } from '../store/flow/action-creators';
import { getIsAccountCreationStep } from './getIsAccountCreationStep';
import { maybeSkipPrefilled } from './maybeSkipPrefilled';
export const setNextStep = ({
  rebuilder,
  accountCreated = false
} = {}) => (dispatch, getState) => {
  const state = getState();
  const transformedFlow = decideBranch(state, dispatch);
  let flowSteps = maybeSkipPrefilled(transformedFlow, state);
  flowSteps = rebuilder ? rebuilder(flowSteps) : flowSteps;

  if (!flowSteps) {
    return null;
  }

  const isAccountCreationStep = getIsAccountCreationStep(getState(), flowSteps);

  if (isAccountCreationStep && !accountCreated) {
    return dispatch(finishSignup());
  } else {
    return dispatch(goNextStep({
      step: flowSteps[0],
      nextSteps: flowSteps.slice(1)
    }));
  }
};